import React from 'react';
import { X } from 'lucide-react';
import { Button } from '../../ui/button';
import { buildMessagePreview } from '../../../hooks/useCrmChat';

function previewText(replyTo) {
  if (!replyTo) return '';
  if (replyTo.body_preview) return replyTo.body_preview;
  return buildMessagePreview(replyTo);
}

export default function CrmChatReplyPreview({ replyTo, onCancel }) {
  if (!replyTo) return null;

  return (
    <div className="mx-3 mb-1 px-3 py-2 rounded-xl border-l-4 border-emerald-500 bg-muted/60 flex items-start gap-2 animate-in slide-in-from-bottom-2 fade-in duration-200">
      <div className="flex-1 min-w-0">
        <div className="text-xs font-semibold text-emerald-600 truncate">{replyTo.sender_name}</div>
        <div className="text-xs text-muted-foreground truncate">{previewText(replyTo)}</div>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-7 w-7 shrink-0"
        onClick={onCancel}
        aria-label="Cancel reply"
      >
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
